import { createContext, useContext } from "react";
import { HubConnection } from "@microsoft/signalr";

export interface SignalRContextType {
	connection: HubConnection | null;
	isConnectionLoading: boolean;
	isReconnecting: boolean;
	connectionError: string | null;
}

const SignalRContext = createContext<SignalRContextType>({
	connection: null,
	isConnectionLoading: false,
	isReconnecting: false,
	connectionError: null,
});

export const useSignalRContext = () => useContext(SignalRContext);

export default SignalRContext;